<template>
  <v-card :outlined="isoutlined" :tile="istile" min-height="300" :color="color" class="pb-2">
    <slot name="header">
      <v-sheet class="pl-4 text-truncate d-flex justify-start align-center" color="light-blue darken-3 white--text" height="40">
        <v-icon color="white">mdi-view-grid</v-icon>
        <div class="divider"></div>
        <span v-if="$store.state.lang == 'cn'" class="text-button">分类导航</span>
        <span v-else class="text-button">Category</span>
      </v-sheet>
    </slot>
    <v-overlay opacity="0.2" absolute :value="loading">
      <v-progress-circular indeterminate color="light-blue" width="3" size="30"></v-progress-circular>
    </v-overlay>
    <v-treeview
      :dark="istreedark"
      dense
      hoverable
      :open-on-click = "isopenonclick"
      activatable
      @update:active="update"
      :items="category"
      item-children="child">
      <template v-slot:prepend="{ item }">
        <v-icon color="orange darken-1">mdi-rhombus-medium-outline</v-icon>
      </template>
      <template v-slot:label="{ item }">
        <span class="text-button">{{item[$store.state.lang+'_name']}}</span>
      </template>
    </v-treeview>
  </v-card>
</template>

<script>
export default {
  name: 'Categorytree',
  data(){
    return{
      category:[],
      category_io_api:'category/io/',
      act:[],
      loading:false,
      productlistid:3,
    }
  },
  props:{
    flag:{
      type:Number,
      default:3,
    },
    color:{
      type:String,
      default:'grey lighten-4',
    },
    istreedark:{
      type:Boolean,
      default:false,
    },
    isdark:{
      type:Boolean,
      default:false,
    },
    istile:{
      type:Boolean,
      default:false,
    },
    isoutlined:{
      type:Boolean,
      default:false,
    },
    isopenonclick:{
      type:Boolean,
      default:true,
    },
  },
  computed:{
    lang(){
      return this.$store.state.lang;
    },
  },
  methods:{
    //避免再次点击nav,active数组清空
    update(active){
      if(active.length){
        this.act = active;
      }
      this.$emit('treeclick',this.act[0]);
    },
    fetch(){
      this.loading = true;
      let postdata = {};
      postdata.startid = this.flag;
      this.$axios.post(this.$store.state.baseurl + this.category_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.category = response.data.data;
                this.loading = false;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
  watch:{
    flag(){
      this.fetch();
    }
  }
}
</script>

<style scoped>
.divider{
  height:50%;
  width:2px;
  background:#fff;
  margin:0 8px;
}
</style>
